import { render, staticRenderFns } from "./VestList.vue?vue&type=template&id=56f945ab&"
import script from "./VestList.vue?vue&type=script&lang=js&"
export * from "./VestList.vue?vue&type=script&lang=js&"
import style0 from "./VestList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports